module.exports = __webpack_public_path__ + "static/img/home_img2@2x.254e9a25.png";